import { baseApi } from 'services/baseApi';
import { AppConstants } from 'constants/index';
import { ReleaseNote, ReleaseNoteItem } from 'features/releaseNote/types';
import { cacheTags } from 'constants/cacheTags';

export const releaseNoteApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getReleaseNote: builder.query<ReleaseNote, number>({
      query: (id) => {
        const { DataCollector, ReleaseNotes } = AppConstants.api;
        return {
          url: [DataCollector, ReleaseNotes, id],
        };
      },
    }),
    markAsSeenReleaseNote: builder.mutation<void, number>({
      query: (id) => {
        const { DataCollector, ReleaseNotes, Seen } = AppConstants.api;
        return {
          method: AppConstants.methods.PUT,
          url: [DataCollector, ReleaseNotes, id, Seen],
        };
      },
      invalidatesTags: [cacheTags.LatestReleaseNote],
    }),
    getLatestReleaseNote: builder.query<ReleaseNoteItem, void>({
      query: () => {
        const { DataCollector, ReleaseNotes, Latest } = AppConstants.api;
        return {
          url: [DataCollector, ReleaseNotes, Latest],
        };
      },
      providesTags: [cacheTags.LatestReleaseNote],
    }),
    getResourceReleaseNotes: builder.query<ReleaseNoteItem[], void>({
      query: () => {
        const { ReportingAdmin, Resource, ReleaseNotes } = AppConstants.api;
        return {
          url: [ReportingAdmin, Resource, ReleaseNotes],
        };
      },
    }),
  }),
});

export const {
  useGetReleaseNoteQuery, useGetLatestReleaseNoteQuery, useMarkAsSeenReleaseNoteMutation, useGetResourceReleaseNotesQuery,
} = releaseNoteApi;
